import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'
import { MenuItemUnion } from 'packages/web-layout/types'

export const useStudentManagementMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/studentManagement',
      label: (
        <GrowpIcon
          name="Student"
          text="学生管理"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '学生管理',
      height: 40,
      perm: PermEnum.FormalStudent,
    },
  ]
}
